import { Menu, MenuItem } from '@mui/material';

export interface MasterIndexActionsMenuItem<T> {
  key: string;
  label: string;
  onSelect: (item: T) => void;
  visible?: boolean | ((item: T) => boolean);
  destructive?: boolean;
}

interface MasterIndexActionsMenuProps<T> {
  anchorEl: HTMLElement | null;
  selectedItem: T | null;
  onClose: () => void;
  actions: MasterIndexActionsMenuItem<T>[];
}

export const MasterIndexActionsMenu = <T,>({
  anchorEl,
  selectedItem,
  onClose,
  actions,
}: MasterIndexActionsMenuProps<T>) => {
  const visibleActions = selectedItem
    ? actions.filter((action) => {
        if (typeof action.visible === 'function') {
          return action.visible(selectedItem);
        }

        return action.visible !== false;
      })
    : [];

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      {visibleActions.map((action) => (
        <MenuItem
          key={action.key}
          onClick={() => {
            if (!selectedItem) return;
            action.onSelect(selectedItem);
            onClose();
          }}
          sx={action.destructive ? { color: 'error.main' } : undefined}
        >
          {action.label}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default MasterIndexActionsMenu;
